import React from 'react';

const LCVStageTable = ({
  topLeft,
  topCenter,
  topRight,
  middleLeft,
  middleCenter,
  middleRight,
  bottomLeft,
  bottom,
  className = '',
}) => (
  <div className={`lcv-stage-table ${className}`.trim()}>
    <div className="lcv-stage-row lcv-stage-row-top">
      <div className="lcv-stage-slot lcv-stage-slot-top-left">{topLeft}</div>
      <div className="lcv-stage-slot lcv-stage-slot-top-center">{topCenter}</div>
      <div className="lcv-stage-slot lcv-stage-slot-top-right">{topRight}</div>
    </div>

    <div className="lcv-stage-row lcv-stage-row-middle">
      <div className="lcv-stage-slot lcv-stage-slot-middle-left">{middleLeft}</div>
      <div className="lcv-stage-slot lcv-stage-slot-middle-center">{middleCenter}</div>
      <div className="lcv-stage-slot lcv-stage-slot-middle-right">{middleRight}</div>
    </div>

    <div className="lcv-stage-row lcv-stage-row-bottom">
      <div className="lcv-stage-slot lcv-stage-slot-bottom-left">{bottomLeft}</div>
      <div className="lcv-stage-slot lcv-stage-slot-bottom">{bottom}</div>
    </div>
  </div>
);

export default LCVStageTable;
